import { Button } from '@material-ui/core'
import { useState } from 'react'
import ApiCopros from '../api/apiCopros'

const ToggleArchiveStatusButton = ({ record, refresh }) => {
  const apiCopros = new ApiCopros()
  const [loading, setLoading] = useState(false)
  if (!record) {
    return <></>
  }

  const archive = async () => {
    setLoading(true)
    await apiCopros.updateCopro(record.id, {
      path: 'archive',
      is_archived: true,
    })
    setLoading(false)
  }
  const desarchive = async () => {
    setLoading(true)
    await apiCopros.updateCopro(record.id, {
      path: 'archive',
      is_archived: false,
    })
    setLoading(false)
  }

  const handleToggleStatus = async (e) => {
    e.stopPropagation()
    e.preventDefault()
    if (record.is_archived === true) {
      await desarchive()
    } else {
      await archive()
    }
    refresh()
  }

  return (
    <Button
      variant="contained"
      color="primary"
      label="Archiver"
      onClick={handleToggleStatus}
      disabled={loading}
      size="small"
      disableElevation
    >
      {record.is_archived === true ? 'Desarchiver' : 'Archiver'}
    </Button>
  )
}

export default ToggleArchiveStatusButton
